export enum PaymentHistoryStatus {
	SENDING_TO_THE_BANK = '-1',
	IN_PROCESSING = '-2',
	NOT_DETERMINED = '0',
	INTRODUCED_INCOMING = '1',
	CONDUCTED_INCOMING = '3',
	PROCESSING_DOCUMENT = '5',
	REMOVED_INCOMING = '6',
	REJECTED_TCR = '7',
	REJECTED_BY_BANK = '9',
	UNREJECTED = '14',
	POSTPONED_INCOMING = '16',
	SENT_TO_TCR = '28',
	SENT_TO_GO = '29',
	TRANSACTION_PENDING = '51',
	DELETED_BY_ACCOUNTANT = '-3',
	DELETED_BY_DIRECTOR = '-4',
	ON_ACCOUNTANT_LIST = '-5',
	ON_DIRECTOR_LIST = '-6',
	ON_PROCESSING_LIST = '-7',
	BANK_TREATMENT = '-8',
	DELETED_BY_BANK = '-9',
	APPROVED = '2',
	APPROVED_CODE = '-12',
	UNKNOWN_30 = '30',
	UNKNOWN_31 = '31',
	UNKNOWN_60 = '60',
	UNKNOWN_61 = '61',
	UNKNOWN_114 = '114',
	UNKNOWN_192 = '192',
	PARTIALLY_APPROVED = '10',
	UNSENT = '-14',
}

export enum PaymentHistoryPayrollStatus {
	DRAFT = '-1',
	DELETED_BY_DIRECTOR = '-2',
	ON_DIRECTOR_LIST = '-3',
	DELETED_BY_ACCOUNTANT = '-7',
	ON_ACCOUNTANT_LIST = '-6',
	UNDEFINED = '0',
	INTRODUCED_INCOMING = '1',
	APPROVED = '2',
	CONDUCTED_INCOMING = '3',
	SENDING_TO_THE_BANK = '-5',
	DELETED_BY_BANK = '6',
	REJECTED_TCR = '7',
	UNREJECTED = '14',
	POSTPONED_INCOMING = '16',
	SENT_TO_TCR = '28',
	SENT_TO_GO = '29',
}